import axios from '../lib/axios';
import { getEndDate } from '../lib/utils';

export const SET_ASSIGNMENT_ERROR = 'SET_ASSIGNMENT_ERROR';

const USER_NOT_AUTHORIZED = 'USER_NOT_AUTHORIZED';
const EXPIRED = 'EXPIRED';
const NOT_STARTED = 'NOT_STARTED';

export const errorType = {
    USER_NOT_AUTHORIZED,
    EXPIRED,
    NOT_STARTED,
};

export const GET_ASSIGNMENT_SUCCESS = 'GET_ASSIGNMENT_SUCCESS';
export const GET_ASSIGNMENT_START = 'GET_ASSIGNMENT_START';
export const GET_ASSIGNMENT_ERROR = 'GET_ASSIGNMENT_ERROR';

export const GET_GOOGLE_ASSIGNMENT_SUCCESS = 'GET_GOOGLE_ASSIGNMENT_SUCCESS';
export const GET_GOOGLE_ASSIGNMENT_START = 'GET_GOOGLE_ASSIGNMENT_START';
export const GET_GOOGLE_ASSIGNMENT_ERROR = 'GET_GOOGLE_ASSIGNMENT_ERROR';

export const getAssignmentById = (id) => {
    return getAssignment(id, `/api/assignments/${id}`);
};

export const getAssignmentByUniqueCode = (uniqueCode) => {
    return getAssignment(uniqueCode, `/api/assignments/uniqueCode/${uniqueCode}`);
};

const getAssignment = (id, url) => {
    return async (dispatch) => {
        dispatch({ type: GET_ASSIGNMENT_START });
        try {
            const response = await axios.get(url);
            dispatch({
                type: GET_ASSIGNMENT_SUCCESS,
                payload: response.data,
            });
            return response.data;
        } catch (e) {
            const body = {
                type: GET_ASSIGNMENT_ERROR,
                error: e.message,
            };
            dispatch(body);
            return body;
        }
    };
};

export const getGoogleAssignmentEndDate = (courseId, googleCourseWorkId) => {
    return async (dispatch) => {
        dispatch({ type: GET_GOOGLE_ASSIGNMENT_START });
        try {
            const { result } = await window.gapi.client.classroom.courses.courseWork.get({
                courseId: courseId,
                id: googleCourseWorkId,
            });

            const endDate = getEndDate(result);

            dispatch({
                type: GET_GOOGLE_ASSIGNMENT_SUCCESS,
                payload: endDate,
            });
            return endDate;
        } catch (e) {
            dispatch({
                type: GET_GOOGLE_ASSIGNMENT_ERROR,
                error: e.message,
            });
        }
    };
};

export const setAssignmentError = (errorType) => {
    return async (dispatch) => {
        dispatch({ type: SET_ASSIGNMENT_ERROR, payload: errorType });
    };
};
